<div class="tickets">
  <div *ngIf="tickets; else loader">
    <div *ngIf="tickets.length; else noData">
      <div *ngFor="let ticket of tickets">
        <div class="ticket-row my-tickets">
          <div class="ticket-card">
            <div class="row disk-top-display">
              <div class="ticket-card__item col-md-3">
                <!-- <div class="borderd"> -->
                <div class="ticket-card__item__ticket-img">
                  <img
                    style="
                      width: -webkit-fill-available;
                      height: 100px;
                      padding: 0 10px;
                    "
                    crossorigin="anonymous"
                    class="url"
                    [src]="
                      ticket.event?.image?.image?.url ||
                      '/assets/images/events/default-img.svg'
                    "
                  />
                </div>
                <!-- </div> -->
              </div>

              <div class="ticket-card__item col-md-3">
                <div class="borderd">
                  <div class="ticket-card__item__ticket-name">
                    {{
                      translate.currentLang === "ar"
                        ? ticket.event.nameAr
                        : ticket.event.nameEn
                    }}
                  </div>

                  <div class="ticket-card__item__ticket-address">
                    <a
                      [href]="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        ticket.event.lat +
                        ',' +
                        ticket.event.lng
                      "
                      target="_blank"
                    >
                      <img
                        src="assets/images/icons/export.svg"
                        alt="map"
                        style="cursor: pointer"
                      />
                      <span class="mx-2 ticket-card__item__ticket-address">
                        {{ "Tickets.AddressDetails" | translate }}
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <div class="ticket-card__item col-sm-5 col-md-6">
                <div class="ticket-card__item__ticket-details-section">
                  <div>
                    <div
                      class="ticket-card__item__ticket-label"
                      style="height: 30px"
                    >
                      {{ ticket.orders.length }}
                      {{ "Tickets.Tickets" | translate }}
                    </div>

                    <div class="ticket-card__item__ticket-content">
                      {{ "Tickets.OrderNumber" | translate }}
                      {{ ticket.number }}
                    </div>
                  </div>

                  <div>
                    <div class="ticket-card__item__ticket-label mb-0">
                      <span *ngIf="ticket.grandTotal === 0">
                        {{ "free" | translate }}
                      </span>

                      <span *ngIf="ticket.grandTotal > 0">
                        <span
                          [innerHTML]="
                            ticket.grandTotal
                              | customCurrency
                                : 'SAR'
                                : 'symbol'
                                : '#282d35'
                                : 30
                          "
                        ></span>
                      </span>
                    </div>
                  </div>

                  <div class="ticket-card__item__ticket-btns">
                    <button
                      *ngIf="
                        myTicketsStatus ===
                          MyTicketsStatusEnum.UpComingTickets &&
                        ticket.transferOrderStatus !== 'UNDERTRANSFER' &&
                        ticket.id !== '$$$$'
                      "
                      class="ticket-card__item__btn download-btn mb-2"
                      (click)="downloadTicket(ticket.id)"
                    >
                      <div>
                        <span class="fw-bold">
                          {{ "Tickets.DownloadAllTickets" | translate }}
                        </span>
                      </div>
                    </button>

                    <button
                      class="ticket-card__item__btn tickets-btn mb-2"
                      (click)="toggleExpand(ticket)"
                    >
                      <div>
                        <i
                          *ngIf="ticket.expanded"
                          class="fa fa-arrow-up mx-2"
                        ></i>
                        <i
                          *ngIf="!ticket.expanded"
                          class="fa fa-arrow-down mx-2"
                        ></i>
                        <span class="fw-bold ticket-card__item__btn-text">
                          {{
                            ticket.expanded
                              ? ("Tickets.HideTickets" | translate)
                              : ("Tickets.ViewTickets" | translate)
                          }}
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="ticket.expanded"
              class="ticket-card__item__expandable-content disk-top-display"
            >
              <div *ngFor="let order of ticket.orders">
                <div class="ticket-card__item__expandable-content-item">
                  <!-- <div class=""> -->
                  <div class="ticket-card__item__expandable-content-item-first">
                    <div class="ticket-card__item__expandable-content-qr">
                      <div class="qrcodFrame">
                        <div
                          class="container_"
                          *ngIf="
                            order.approvalStatus ===
                              ApprovalStatusEnum.WaitingApproval ||
                            order.approvalStatus ===
                              ApprovalStatusEnum.DeclinedApproval
                          "
                        >
                          <div class="tag">
                            <div
                              class="tag-text"
                              *ngIf="
                                order.approvalStatus ===
                                ApprovalStatusEnum.WaitingApproval
                              "
                            >
                              {{ "Tickets.WaitingApproval" | translate }}
                            </div>
                            <div
                              class="tag-text"
                              *ngIf="
                                order.approvalStatus ===
                                ApprovalStatusEnum.DeclinedApproval
                              "
                            >
                              {{ "Tickets.Rejected" | translate }}
                            </div>
                          </div>
                          <img
                            src="{{
                              'https://api.qrserver.com/v1/create-qr-code/?data=' +
                                order.id +
                                '&margin=30&height=100'
                            }}"
                            alt=""
                            style="opacity: 0.4"
                            class="image"
                          />
                        </div>

                        <img
                          *ngIf="
                            order.approvalStatus === ApprovalStatusEnum.Approved
                          "
                          src="{{
                            'https://api.qrserver.com/v1/create-qr-code/?data=' +
                              order.id +
                              '&margin=30&height=100'
                          }}"
                          alt=""
                        />
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-qr-number"
                      >
                        {{ "Tickets.TicketNumber" | translate }}
                        {{ order.number }}
                      </div>
                    </div>

                    <div>
                      <div
                        class="ticket-card__item__expandable-content-item-label"
                      >
                        {{ "Tickets.FullName" | translate }}
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-item-content"
                      >
                        {{ ticket.metadata.name.first }}
                        {{ ticket.metadata.name.last }}
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-item-sub-content"
                        style="direction: ltr; float: inline-start"
                      >
                        {{ ticket.metadata.mobile }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div
                      class="ticket-card__item__expandable-content-item-label"
                    >
                      {{ "Tickets.TicketPrice" | translate }}
                    </div>

                    <div
                      class="ticket-card__item__expandable-content-item-content"
                    >
                      <span *ngIf="order.total > 0">
                        <span
                          [innerHTML]="
                            order.total
                              | customCurrency
                                : 'SAR'
                                : 'symbol'
                                : '#282d35'
                                : 30
                          "
                        ></span>
                      </span>
                      <span *ngIf="order.total === 0">
                        {{ "free" | translate }}
                      </span>
                    </div>

                    <div
                      *ngIf="order.total > 0"
                      class="ticket-card__item__expandable-content-item-sub-content"
                    >
                      <span
                        [innerHTML]="
                          order.ticket.price
                            | customCurrency : 'SAR' : 'symbol' : '#718096' : 26
                        "
                      ></span
                      >+
                      <span
                        [innerHTML]="
                          order.vat
                            | customCurrency : 'SAR' : 'symbol' : '#718096' : 26
                        "
                      ></span>
                      {{ "Tickets.Tax" | translate }}
                    </div>
                  </div>

                  <div style="width: 32%">
                    <div
                      class="ticket-card__item__expandable-content-item-label"
                    >
                      {{ "Tickets.TicketType" | translate }}
                    </div>

                    <div
                      class="ticket-card__item__expandable-content-item-content"
                    >
                      <span *ngIf="translate.currentLang === 'ar'">
                        {{ order.ticket.nameAr }}</span
                      >
                      <span *ngIf="translate.currentLang === 'en'">
                        {{ order.ticket?.nameEn || order.ticket.nameAr }}</span
                      >
                    </div>

                    <div
                      class="ticket-card__item__expandable-content-item-sub-content"
                    >
                      <div
                        *ngIf="!order?.schedule?.startAt"
                        class="col-auto ticket-card__item__expandable-content-info-date-details-with-details"
                      >
                        {{
                          "come-anytime-days"
                            | translate
                              : {
                                  day1:
                                    ticket.event.schedules[0]?.startAt * 1000
                                    | localizedDate
                                      : "d MMM"
                                      : translate.currentLang,
                                  day2:
                                    ticket.event.schedules[
                                      ticket.event.schedules.length - 1
                                    ]?.startAt * 1000
                                    | localizedDate
                                      : "MMM d, y"
                                      : translate.currentLang,
                                  t1:
                                    ticket.event.schedules[0]?.startAt * 1000
                                    | localizedDate
                                      : "hh:mm a"
                                      : translate.currentLang,
                                  t2:
                                    ticket.event.schedules[
                                      ticket.event.schedules.length - 1
                                    ]?.startAt * 1000
                                    | localizedDate
                                      : "hh:mm a"
                                      : translate.currentLang
                                }
                        }}
                      </div>

                      <div class="d-flex gap-3 mobile" *ngIf="order.schedule">
                        <div class="d-flex gap-1 align-items-center">
                          <img
                            style="width: 17px"
                            src="assets/images/tickets/calendar.svg"
                          />
                          <p class="mb-0 time" style="direction: ltr">
                            {{
                              order?.schedule?.startAt * 1000
                                | localizedDate
                                  : "EEEE, MMM d, y"
                                  : translate.currentLang
                            }}
                          </p>
                        </div>

                        <div
                          class="d-flex align-items-center gap-1"
                          *ngIf="order?.time?.startAt"
                        >
                          <img
                            style="width: 17px"
                            src="assets/images/tickets/clock.svg"
                          />
                          <p class="mb-0 time" style="direction: ltr">
                            {{ order?.time?.startAt }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mobile-card mobile-display">
              <div class="ticket-card__item__ticket-img">
                <img
                  crossorigin="anonymous"
                  style="width: -webkit-fill-available; height: 100px"
                  class="url"
                  [src]="
                    ticket.event?.image?.image?.url ||
                    '/assets/images/events/default-img.svg'
                  "
                />
              </div>
              <div class="mobile-card__details">
                <div class="mobile-card__details-first">
                  <div class="ticket-card__item__ticket-name">
                    {{
                      translate.currentLang === "ar"
                        ? ticket.event.nameAr
                        : ticket.event.nameEn
                    }}
                  </div>

                  <div class="ticket-card__item__ticket-address">
                    <a
                      [href]="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        ticket.event.lat +
                        ',' +
                        ticket.event.lng
                      "
                      target="_blank"
                    >
                      <img
                        src="assets/images/icons/export.svg"
                        alt="map"
                        style="cursor: pointer"
                      />
                      <span class="mx-2 ticket-card__item__ticket-address">
                        {{ "Tickets.AddressDetails" | translate }}
                      </span>
                    </a>
                  </div>
                </div>

                <div class="mobile-card__details-second">
                  <div class="mobile-card__details-second-tickets">
                    <div class="ticket-card__item__ticket-label">
                      {{ ticket.orders.length }}
                      {{ "Tickets.Tickets" | translate }}
                    </div>

                    <div class="ticket-card__item__ticket-content">
                      {{ "Tickets.OrderNumber" | translate }}
                      {{ ticket.number }}
                    </div>
                  </div>

                  <div class="mobile-card__details-second-price">
                    <div class="ticket-card__item__ticket-label mb-0">
                      <span *ngIf="ticket.grandTotal > 0">
                        <span
                          [innerHTML]="
                            ticket.grandTotal
                              | customCurrency
                                : 'SAR'
                                : 'symbol'
                                : '#282d35'
                                : 30
                          "
                        ></span>
                      </span>

                      <span *ngIf="ticket.grandTotal === 0">
                        {{ "free" | translate }}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  class="mobile-card__details-btns"
                  [ngClass]="{
                    'mobile-card__details-btns-single':
                      myTicketsStatus === MyTicketsStatusEnum.PastTickets
                  }"
                >
                  <button
                    *ngIf="
                      myTicketsStatus === MyTicketsStatusEnum.UpComingTickets &&
                      ticket.transferOrderStatus !== 'UNDERTRANSFER' &&
                      ticket.id !== '$$$$'
                    "
                    class="ticket-card__item__btn download-btn mb-2"
                    (click)="downloadTicket(ticket.id)"
                  >
                    <div>
                      <span class="fw-bold">
                        {{ "Tickets.DownloadAllTickets" | translate }}
                      </span>
                    </div>
                  </button>

                  <button
                    class="ticket-card__item__btn tickets-btn mb-2"
                    (click)="toggleExpand(ticket)"
                  >
                    <div>
                      <i
                        *ngIf="ticket.expanded"
                        class="fa fa-arrow-up mx-2"
                      ></i>
                      <i
                        *ngIf="!ticket.expanded"
                        class="fa fa-arrow-down mx-2"
                      ></i>
                      <span class="fw-bold ticket-card__item__btn-text">
                        {{
                          ticket.expanded
                            ? ("Tickets.HideTickets" | translate)
                            : ("Tickets.ViewTickets" | translate)
                        }}
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div
                *ngIf="ticket.expanded"
                class="ticket-card__item__expandable-content"
              >
                <div *ngFor="let order of ticket.orders">
                  <div class="ticket-card__item__expandable-content-item">
                    <!-- <div class=""> -->
                    <div
                      class="ticket-card__item__expandable-content-item-first"
                    >
                      <div class="ticket-card__item__expandable-content-qr">
                        <div class="qrcodFrame">
                          <div
                            class="container_"
                            *ngIf="
                              order.approvalStatus ===
                                ApprovalStatusEnum.WaitingApproval ||
                              order.approvalStatus ===
                                ApprovalStatusEnum.DeclinedApproval
                            "
                          >
                            <div class="tag">
                              <div
                                class="tag-text"
                                *ngIf="
                                  order.approvalStatus ===
                                  ApprovalStatusEnum.WaitingApproval
                                "
                              >
                                {{ "Tickets.WaitingApproval" | translate }}
                              </div>
                              <div
                                class="tag-text"
                                *ngIf="
                                  order.approvalStatus ===
                                  ApprovalStatusEnum.DeclinedApproval
                                "
                              >
                                {{ "Tickets.Rejected" | translate }}
                              </div>
                            </div>
                            <img
                              src="{{
                                'https://api.qrserver.com/v1/create-qr-code/?data=' +
                                  order.id +
                                  '&margin=30&height=100'
                              }}"
                              alt=""
                              style="opacity: 0.4"
                              class="image"
                            />
                          </div>

                          <img
                            *ngIf="
                              order.approvalStatus ===
                              ApprovalStatusEnum.Approved
                            "
                            src="{{
                              'https://api.qrserver.com/v1/create-qr-code/?data=' +
                                order.id +
                                '&margin=30&height=100'
                            }}"
                            alt=""
                          />
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-qr-number"
                        >
                          {{ "Tickets.TicketNumber" | translate }}
                          {{ order.number }}
                        </div>
                      </div>

                      <div>
                        <div
                          class="ticket-card__item__expandable-content-item-label"
                        >
                          {{ "Tickets.TicketType" | translate }}
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-content"
                        >
                          <span *ngIf="translate.currentLang === 'ar'">
                            {{ order.ticket.nameAr }}</span
                          >
                          <span *ngIf="translate.currentLang === 'en'">
                            {{
                              order.ticket?.nameEn || order.ticket.nameAr
                            }}</span
                          >
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-sub-content"
                        >
                          <div
                            *ngIf="!order?.schedule?.startAt"
                            class="col-auto ticket-card__item__expandable-content-info-date-details-with-details"
                            style="font-size: 11px"
                          >
                            {{
                              "come-anytime-days"
                                | translate
                                  : {
                                      day1:
                                        ticket.event.schedules[0]?.startAt *
                                          1000
                                        | localizedDate
                                          : "d MMM"
                                          : translate.currentLang,
                                      day2:
                                        ticket.event.schedules[
                                          ticket.event.schedules.length - 1
                                        ]?.startAt * 1000
                                        | localizedDate
                                          : "MMM d, y"
                                          : translate.currentLang,
                                      t1:
                                        ticket.event.schedules[0]?.startAt *
                                          1000
                                        | localizedDate
                                          : "hh:mm a"
                                          : translate.currentLang,
                                      t2:
                                        ticket.event.schedules[
                                          ticket.event.schedules.length - 1
                                        ]?.startAt * 1000
                                        | localizedDate
                                          : "hh:mm a"
                                          : translate.currentLang
                                    }
                            }}
                          </div>

                          <div
                            class="d-flex gap-1 mobile"
                            *ngIf="order.schedule"
                          >
                            <div class="d-flex align-items-center">
                              <img
                                style="width: 17px"
                                src="assets/images/tickets/calendar.svg"
                              />
                              <p class="mb-0 time" style="direction: ltr">
                                {{
                                  order?.schedule?.startAt * 1000
                                    | localizedDate
                                      : "EEEE, MMM d, y"
                                      : translate.currentLang
                                }}
                              </p>
                            </div>

                            <div
                              class="d-flex align-items-center"
                              *ngIf="order?.time?.startAt"
                            >
                              <img
                                style="width: 17px"
                                src="assets/images/tickets/clock.svg"
                              />
                              <p class="mb-0 time" style="direction: ltr">
                                {{ order?.time?.startAt }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="ticket-card__item__expandable-content-item-second"
                    >
                      <div
                        class="ticket-card__item__expandable-content-item-second-price"
                      >
                        <div
                          class="ticket-card__item__expandable-content-item-label"
                        >
                          {{ "Tickets.TicketPrice" | translate }}
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-content"
                        >
                          <span *ngIf="order.total > 0">
                            <span
                              [innerHTML]="
                                order.total
                                  | customCurrency
                                    : 'SAR'
                                    : 'symbol'
                                    : '#282d35'
                                    : 30
                              "
                            ></span>
                          </span>
                          <span *ngIf="order.total === 0">
                            {{ "free" | translate }}
                          </span>
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-sub-content"
                          *ngIf="order.total > 0"
                        >
                          <span
                            [innerHTML]="
                              order.ticket.price
                                | customCurrency
                                  : 'SAR'
                                  : 'symbol'
                                  : '#718096'
                                  : 26
                            "
                          ></span>
                          +
                          <span
                            [innerHTML]="
                              order.vat
                                | customCurrency
                                  : 'SAR'
                                  : 'symbol'
                                  : '#718096'
                                  : 26
                            "
                          ></span>
                          {{ "Tickets.Tax" | translate }}
                        </div>
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-item-second-name"
                      >
                        <div
                          class="ticket-card__item__expandable-content-item-label"
                        >
                          {{ "Tickets.FullName" | translate }}
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-content"
                        >
                          {{ ticket.metadata.name.first }}
                          {{ ticket.metadata.name.last }}
                        </div>

                        <div
                          class="ticket-card__item__expandable-content-item-sub-content"
                          style="direction: ltr; float: inline-start"
                        >
                          {{ ticket.metadata.mobile }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-pagination
        *ngIf="ticketsMeta"
        [meta]="ticketsMeta"
        (goPage)="goToPage($event)"
        (goNext)="onNext()"
        (goPrev)="onPrev()"
      >
      </app-pagination>
    </div>
  </div>
</div>
<ng-template #noData>
  <div class="mb-5 text-center">
    <div class="text-center">
      <img src="assets/images/tickets/no-tickets.png" alt="No-tickets" />
    </div>
    <div class="pt-5">
      <h2 class="block-title">
        {{ "Tickets.no-tickets-available" | translate }}
      </h2>
      <p class="block-desc">
        {{ "Tickets.no-tickets-associated" | translate }}
      </p>
    </div>
  </div>
</ng-template>

<ng-template #loader>
  <!-- <app-loading></app-loading> -->
</ng-template>
